import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import MessengerChat from "./MessengerChat";

import "../styles.css";

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div>
      <nav className="navbar">
        {/* Hamburger Icon */}
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>

        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          {/* Add logo inside the menu for mobile */}
          {menuOpen && (
            <img
              src="https://xfiremusic.com.au/images/xfirelogowhite.jpg"
              alt="XFire Music Logo"
              className="menu-logo"
            />
          )}
          <li>
            <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/shop" className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>
              Visit Our Store
            </NavLink>
          </li>
          <li>
            <NavLink to="/equipment-hire" className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>
              Equipment Hire
            </NavLink>
          </li>
          <li>
            <NavLink to="/recording" className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>
              Recording
            </NavLink>
          </li>
          <li>
            <NavLink to="/production" className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>
              Production
            </NavLink>
          </li>
          <li>
            <NavLink to="/lessons" className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setMenuOpen(false)}>
              Lessons
            </NavLink>
          </li>
        </ul>
      </nav>

      <div className="logo">
        <img
          src="https://xfiremusic.com.au/images/xfirelogowhite.jpg"
          alt="XFire Music Logo"
          className="logo"
        />
        <a href="tel:+61457170347">
          <button className="call-now-btn">📞 Call Now</button>
        </a>
        <MessengerChat />
      </div>
    </div>
  );
};

export default NavBar;
